import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { branch, renderComponent } from 'recompose';
import { compose, prop } from 'ramda';

import connect from 'app/libs/connect';
import { isUserPremium } from 'app/features/user/selectors';
import { hasDirectToPayUserJustLoggedIn } from 'app/router/selectors';
import withCriteoTagTracker from 'app//analytics/enhancers/withCriteoAnalytics';
import { BASKET_TAG } from 'app/analytics/constants/criteo';
import LandingRedirect from 'app/router/LandingRedirect';
import AlreadyPremiumRedirect from 'app/router/AlreadyPremiumRedirect';
import NoBillingPlanChoice from 'app/features/billing/components/Billing/NoBillingPlanChoice';
import {
  isSelectedProductWithOnePlan,
  hasNoSkuSelected,
} from 'app/features/products/selectors';
import S from 'app/features/billing/components/Billing/Billing.styled';
import Text from 'app/components/layout/Text.styled';
import Plans from 'app/features/billing/components/Plans/Plans';
import BackgroundImage from 'app/features/billing/components/Billing/BackgroundImage';
import FloatingLayout from 'app/components/layout/FloatingLayout';
import Heading from 'app/components/layout/Heading.styled';
import CheckoutButton from 'app/features/billing/components/Billing/CheckoutButton';
import Footnote from 'app/features/billing/components/Billing/Footnote';

const UI = ({ hasDirectToPayUserJustLoggedIn }) => (
  <FloatingLayout>
    <FloatingLayout.ContentBlock>
      <S.Billing>
        <BackgroundImage />
        <S.ContentWrapper>
          <Heading size="xl" as={S.Title} type="heavy">
            <FormattedMessage
              id={
                hasDirectToPayUserJustLoggedIn
                  ? 'billing_title_ineligible'
                  : 'billing_title_default'
              }
            />
          </Heading>
          {hasDirectToPayUserJustLoggedIn && (
            <Text as={S.Subtitle} size="xl">
              <FormattedMessage
                id="billing_subtitle_ineligible"
                values={{ linebreak: <br /> }}
              />
            </Text>
          )}
          <Plans />
          <S.ButtonHolder>
            <CheckoutButton
              testId="billing-proceed-to-checkout-btn"
              textKey="buttons_proceed_to_checkout"
            />
          </S.ButtonHolder>
        </S.ContentWrapper>
        <Footnote />
      </S.Billing>
    </FloatingLayout.ContentBlock>
  </FloatingLayout>
);

UI.propTypes = {
  hasDirectToPayUserJustLoggedIn: PropTypes.bool.isRequired,
};

UI.displayName = 'Billing';

const state = {
  isUserPremium,
  hasDirectToPayUserJustLoggedIn,
  hasNoSkuSelected,
  hasNoBillingPlanChoice: isSelectedProductWithOnePlan,
};

const Billing = compose(
  connect(state),
  withCriteoTagTracker(BASKET_TAG),
  branch(prop('isUserPremium'), renderComponent(AlreadyPremiumRedirect)),
  branch(prop('hasNoSkuSelected'), renderComponent(LandingRedirect)),
  branch(prop('hasNoBillingPlanChoice'), renderComponent(NoBillingPlanChoice)),
)(UI);

export { UI };

export default Billing;
